import React, { Component } from "react";
import styles from "../../../assets/css/modules/shared/groups/summary-detail.css";
import ToggleDrawer from "../containers/ToggleDrawer";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";
import printStyles from "../../../assets/css/modules/print.css";

export default class SummaryDetailRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false
    };
  }

  render() {
    return (
      <React.Fragment>
        <div
          className={
            this.props.header ? styles.header + " " + styles.row : styles.row
          }
        >
          <div className={styles.title}>
            {this.props.icon ? (
              <i className={styles.icon + " " + this.props.icon} />
            ) : null}{" "}
            {this.props.title}
          </div>
          {this.props.tooltipIcon ? (
            <i
              className={styles.tooltipIcon + " " + this.props.tooltipIcon}
              tabIndex="0"
              onClick={() => {
                this.setState({
                  toolTipVisible: !this.state.toolTipVisible
                });
              }}
              onKeyPress={e => {
                handleKeyPress(e, () => {
                  this.setState({
                    toolTipVisible: !this.state.toolTipVisible
                  });
                });
              }}
              title="Click for more information"
            />
          ) : null}
          <div className={styles.value + " " + this.props.customValueStyle}>
            {this.props.value}
          </div>
          <div className={styles.clearBoth + " " + printStyles.noprint}>
            <ToggleDrawer isOpen={this.state.toolTipVisible}>
              <div className="input-tooltip"> {this.props.tooltipContent}</div>
            </ToggleDrawer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
